let inFlight: Promise<string> | null = null;

/**
 * Single-flight qulfi: bir vaqtda faqat bitta refresh so'rovi ketadi.
 *
 * Bu shunchaki optimallashtirish emas — backend refresh tokenni rotatsiya qiladi
 * va ishlatilgan tokenni qayta yuborish o'g'irlash deb qabul qilinib, foydalanuvchining
 * barcha sessiyalarini bekor qiladi. Parallel refresh aynan shuni keltirib chiqaradi.
 */
export function runRefresh(refreshFn: () => Promise<string>): Promise<string> {
	if (inFlight) {
		return inFlight;
	}

	inFlight = refreshFn().finally(() => {
		inFlight = null;
	});

	return inFlight;
}

/** Faqat testlar uchun. */
export function resetRefreshLock(): void {
	inFlight = null;
}
